<template>
  <div class="animated fadeIn">
    <!-- <StyledDialog>
      <div slot="header">
        <h2>{{seminar.restaurant_edit.CommonName}}</h2>
      </div>
      <div slot="details">
        <div>{{seminar.restaurant_edit.Address1}} {{seminar.restaurant_edit.Address2}}</div>
        <div>{{seminar.restaurant_edit.City }}</div>
      </div>
      <span slot="entityType">location</span>
    </StyledDialog>-->
    <b-row>
      <b-col lg="12">
        <!-- <b-card>
        <div slot="header">User Profile</div>-->
        <b-form @submit.prevent="save">
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <CoolSelect
                  v-model="seminar.artwork_type_edit.MailerTypeID"
                  class="form-input dropdown-content"
                  placeholder="Type"
                  theme="bootstrap"
                  tooltip="Mailer Types"
                  :items="seminar.mailer_types"
                  item-text="MailerTypeName"
                  item-value="MailerTypeID"
                  id="MailerTypeID"
                  @select="manuallyAddDirtyField('MailerTypeID')"
                >
                  <template slot="input-before">
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth">Mailer Type</b-input-group-text>
                    </b-input-group-prepend>
                  </template>
                  <!-- <template slot="item" slot-scope="{ item }">
                    <div class="item">
                      <img :src="item.thumbnail" class="logo" />
                      <span class="item-name">{{ item.CommonName }}</span>
                    </div>
                  </template>-->
                </CoolSelect>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Artwork Type*</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="seminar.artwork_type_edit.ArtworkName"
                    placeholder="Name"
                    required
                    type="text"
                    autocomplete="off"
                    id="ArtworkName"
                    @change.native="addDirtyField"
                  ></b-form-input>
                  <!-- <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-registered appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Description</b-input-group-text>
                  </b-input-group-prepend>

                  <b-form-textarea
                    v-model.lazy="seminar.artwork_type_edit.ArtworkDescription"
                    placeholder="Description"
                    type="text"
                    autocomplete="off"
                    id="ArtworkDescription"
                    v-on:change.native="addDirtyField"
                    rows="3"
                  ></b-form-textarea>
                  <!-- 
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-globe"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <div class="form-group form-actions" style="float:right;">
            <b-button class="mr-2 mt-2" size="md" variant="outline-primary" @click="back">
              <!-- <i class="fa fa-close"></i> -->
              Close
            </b-button>
            <b-button
              class="mr-0 mt-2"
              type="submit"
              size="md"
              variant="primary"
              :disabled="isClean"
            >
              <i class="fa fa-save"></i>
              Save
            </b-button>
          </div>
          <div class="form-group form-actions" style="float:right;">
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismissCountDown"
              fade
              variant="light"
              :dismissed="dismissCountdown=0"
              @dismiss-count-down="countDownChanged"
            >
              Your information has been saved
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismiss2CountDown"
              fade
              variant="danger"
              :dismissed="dismiss2Countdown=0"
              @dismiss-count-down="countDown2Changed"
            >
              Your information could not be saved. Check all fields carefully.
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
          </div>
        </b-form>
        <!-- </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import StyledDialog from "@/components/dialogs/StyledModal.vue";
import { required, email, helpers } from "vuelidate/lib/validators";
const alpha = helpers.regex("alpha", /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/);
import { CoolSelect } from "vue-cool-select";

export default {
  name: "ArtworkProfile",
  data() {
    return {
      selected: [], // Must be an array reference!
      dirtyFields: [],
      show: true,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      showDismissibleAlert: false
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    toggleVisibility() {
      this.seen = !this.seen;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    save() {
      // this.$v.$touch();
      // if (this.$v.$error) {
      //   this.dismiss2CountDown = this.dismiss2Secs;
      // } else {
      //   this.$store
      //     .dispatch("dealership/Save", {
      //       client: this.$store.state.seminar.restaurant_edit,
      //       fields: this.dirtyFields
      //     })
      //     .then(
      //       (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
      //     );
      // }
      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store
          .dispatch("saveOp/BuildSaveOperation")
          .then(
            this.$store
              .dispatch("saveOp/EmitSave")
              .then(
                (this.dirtyFields = [])(
                  (this.dismissCountDown = this.dismissSecs)
                )(this.$store.state.saveOp.DestroySaveOperation)
              )
          );
      }
    },

    addDirtyField: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.value
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    manuallyAddDirtyField(id) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== id
      );
      this.dirtyFields.push({
        FieldName: id,
        FieldValue: this.$store.state.seminar.artwork_type_edit.MailerTypeID
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    }
  },
  computed: {
    ...mapState(["seminar"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    isClean() {
      return this.dirtyFields.length === 0;
    }
  },
  components: {
    StyledDialog,
    CoolSelect
  },
  created() {
      },

  mounted() {
    this.$store.state.saveOp.localUrl = "/Seminar/SaveArtwork/";
    this.$store.state.saveOp.localVariableName = "_a";
    this.$store.state.saveOp.localVariableObject = this.$store.state.seminar.artwork_type_edit;
    this.$store.state.saveOp.localFieldToSet = "ArtworkID";
    this.$store.state.saveOp.localReturnObject = "SaveArtworkResult";
  },
  validations: {
    seminar: {
      artwork_type_edit: {
        ArtworkName: {
          required
        }
      }
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
</style>
